import router from '@/router';
import { useToast } from 'vue-toastification';

const TOKEN_KEY = 'SSCUSER';

// True if the token is missing, unreadable, or past its expiry
export const isTokenExpired = (token = localStorage.getItem(TOKEN_KEY), skewSeconds = 30) => {
  if (!token) return true;
  try {
    const payload = token.split('.')[1];
    if (!payload) return true;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
      .padEnd(Math.ceil(payload.length / 4) * 4, '=');
    const { exp } = JSON.parse(atob(base64));
    if (!exp) return false;
    return Date.now() >= (exp - skewSeconds) * 1000;
  } catch (e) {
    return true;
  }
};

// Toast + clear the token, without navigating (the router guard handles that)
export const clearExpiredSession = () => {
  const toast = useToast();
  toast.error('Session expired. Redirecting to login.', {
    hideProgressBar: false,
    icon: false,
    timeout: 8000,
  });
  localStorage.removeItem(TOKEN_KEY);
  console.warn('Token expired. Redirecting to login.');
};

// For use inside components / axios handlers
export const logoutOnTokenExpired = () => {
  clearExpiredSession();
  router.push('/');
};

// Call from a component: returns true if it redirected
export const checkTokenOrLogout = () => {
  if (isTokenExpired()) {
    logoutOnTokenExpired();
    return true;
  }
  return false;
};